/**
 * TrafficAutoComplete
 * 
 * @Author: Focci
 * @Date: 2023-07-18 17:14:38
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-18 17:14:38
 */

// import PropTypes from 'prop-types'
import Autocomplete from '@page/common/filter/Autocomplete'
import useAbortController from '@hook/useAbortController'
import { debounce, isArray, map } from 'lodash-es'
import { useState } from 'react'
import { fetchProxy } from '@lib/fetch/client'
import { getAddresByKeyword } from './lib'

export default function TrafficAutoComplete({
  ...autocompleteProps
}) {
  const { getSignal } = useAbortController()
  const [options, setOptions] = useState([])
  const [keyword, setKeyword] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleInputChange = debounce(async (e) => {
    const { signal } = getSignal()

    setKeyword(e.target.value)
    !!e.target.value && fetchProxy(
      getAddresByKeyword(e.target.value, '', 10, { signal })
        .then((data) => {
          isArray(data) && setOptions(() => map(data, (item) => ({
            label: item.place_name,
            id: item.id,
            lng: item.center[0],
            lat: item.center[1],
          })))
        }),
      setLoading
    )
  }, 500)
  
  return (
    <Autocomplete
      freeSolo
      size="small"
      loading={loading}
      options={options}
      onInputChange={handleInputChange}
      wraperClassName="focus-within:border-primary"
      renderOption={(props, option) => (
        <div {...props}>
          <span className="text-f.7 line-clamp-1">
            {option.label}
          </span>
        </div>
      )}
      openOnFocus={options.length > 0 && !!keyword}
      {...autocompleteProps}
    />
  )
}

// TrafficAutoComplete.propTypes = {
//   className: PropTypes.string,
// }
